module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-clinical-43b45cb1e2a28ea9b4853d2ae301242e.svg";